<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    顧客管理
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <wj-menu [(value)]="readonly" [isDisabled]="customers.hasChanges()" [header]="'編集モード'">
                                <wj-menu-item [value]="true">ロック</wj-menu-item>
                                <wj-menu-item [value]="false">編集可能</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div class="col-md-3"><span>該当　{{customers.totalCount|number}}　件</span></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #customerGrid [allowAddNew]="true" [allowDelete]="true" [isReadOnly]="readonly" style="height:500px" [itemsSource]="customers">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'顧客番号'" [binding]="'id'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'お名前(全角カタカナ)'" [binding]="'name'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'お名前(漢字)'" [binding]="'nameKanji'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'代表者'" [binding]="'representative'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'郵便番号'" [binding]="'postalCode'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'都道府県'" [binding]="'state'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'市区町村'" [binding]="'city'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'町名'" [binding]="'street'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'建物'" [binding]="'building'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'電話番号'" [binding]="'telephone'" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'携帯番号'" [binding]="'mobile'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'市場参加者'" [binding]="'auction'" [dataType]="'Boolean'" [width]="100"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'屋号'" [binding]="'businessName'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'メールアドレス'" [binding]="'email'" [width]="150"></wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="customers.pageSize" [header]="'ページサイズ'">
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="customers"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="customers"></wj-collection-view-pager>
                        </div>
                    </div>
                    <div class="row">
                        <button *ngIf="!readonly" [disabled]="!customers.hasChanges()" (click)="customers.saveChanges()" class="btn btn-primary btn-block">変更保存</button>
                        <button *ngIf="!readonly" [disabled]="!customers.hasChanges()" (click)="customers.cancelChanges()" class="btn btn-primary btn-block">キャンセル</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
